import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { blogPosts } from "../../data/blog";
import { BLOG_HERO_IMAGE, getBlogImage } from "../../data/blogImages";
import "./blogMain.css";

const cleanExcerpt = (text = "") => text.replace(/\s*\[\.\.\.\]$/, "...");

function ArrowIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
      <path
        d="M7 17 17 7M7 7h10v10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function BlogMain() {
  const [activeCategory, setActiveCategory] = useState("All");

  const posts = useMemo(
    () => blogPosts.filter((post) => post.type === "blog"),
    []
  );

  const categories = useMemo(
    () => ["All", ...new Set(posts.map((post) => post.category))],
    [posts]
  );

  const visiblePosts =
    activeCategory === "All"
      ? posts
      : posts.filter((post) => post.category === activeCategory);

  return (
    <>
      <section className="bm-hero" aria-labelledby="bm-title">
        {BLOG_HERO_IMAGE && (
          <img
            className="bm-hero-bg"
            src={BLOG_HERO_IMAGE}
            alt=""
            aria-hidden="true"
          />
        )}

        <div className="bm-container bm-hero-inner">
          <span className="bm-eyebrow">
            <span className="bm-eyebrow-dot" aria-hidden="true" />
            Insights
          </span>

          <h1 className="bm-hero-title" id="bm-title">
            Blogs
          </h1>

          <p className="bm-hero-text">
            Perspectives from the team building AI&apos;s data layer, from
            annotation best practices to real-world applications.
          </p>
        </div>
      </section>

      <section className="bm-section" aria-label="All blog articles">
        <div className="bm-container">
          {categories.length > 2 && (
            <div className="bm-filters" role="tablist" aria-label="Filter by category">
              {categories.map((category) => (
                <button
                  key={category}
                  type="button"
                  role="tab"
                  aria-selected={activeCategory === category}
                  className={`bm-chip${activeCategory === category ? " is-active" : ""}`}
                  onClick={() => setActiveCategory(category)}
                >
                  {category}
                </button>
              ))}
            </div>
          )}

          {visiblePosts.length > 0 ? (
            <div className="bm-grid">
              {visiblePosts.map((post) => (
                <Link
                  key={post.slug}
                  to={`/resources/blogs/${post.slug}`}
                  className="bm-card"
                >
                  <div className="bm-card-image">
                    {getBlogImage(post) ? (
                      <img src={getBlogImage(post)} alt={post.imageAlt} loading="lazy" />
                    ) : (
                      <div className="bm-card-placeholder" />
                    )}
                    <span className="bm-card-arrow">
                      <ArrowIcon />
                    </span>
                  </div>

                  <div className="bm-card-body">
                    <div className="bm-card-meta">
                      <span className="bm-card-category">
                        {post.category.toUpperCase()}
                      </span>
                      <span className="bm-card-dot" aria-hidden="true" />
                      <span className="bm-card-readtime">{post.readTime}</span>
                    </div>

                    <h2 className="bm-card-title">{post.title}</h2>
                    <p className="bm-card-text">{cleanExcerpt(post.excerpt)}</p>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <p className="bm-empty">No articles in this category yet.</p>
          )}
        </div>
      </section>
    </>
  );
}
